import { Base } from '@studiometa/js-toolkit';

/**
 * Popup component — appears after a delay and can be dismissed.
 */
export default class Popup extends Base {
  static config = {
    name: 'Popup',
    refs: ['close'],
    options: {
      delay: {
        type: Number,
        default: 5000,
      },
    },
  };

  /**
   *
   */
  mounted() {
    console.log('mounted');
    this.timeout = setTimeout(() => {
      console.log('test');
      this.$el.classList.remove('translate-x-[110%]', 'pointer-events-none');
    }, 3000);
  }

  /**
   *
   */
  destroyed() {
    clearTimeout(this.timeout);
  }

  /**
   *
   */
  onCloseClick() {
    clearTimeout(this.timeout);
    this.$el.classList.add('translate-x-[110%]', 'pointer-events-none');
  }
}
